import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { FunctionComponent } from 'react';
import styles from './DateSelectorComponent.module.scss';
import ClickAwayListener from 'components/CreateBooking/UI/ClickAwayListener';

interface DateSelectorComponentProps extends PropsWithChildren {
    id: string;
    expanded: boolean;
    className?: string;
    onExpand: () => void;
    onClickAway: () => void;
}

export const DateSelectorComponent: FunctionComponent<DateSelectorComponentProps> = props => (
    <ClickAwayListener
        onClickAway={props.onClickAway}
        disabled={!props.expanded}
    >
        <div className={styles.container}>
            <div
                id={`booking_div_dropdown_${props.id}`}
                className={styles.expandButton}
                onClick={props.onExpand}
            >
                <FontAwesomeIcon
                    className={styles.icon}
                    icon={props.expanded ? faChevronUp : faChevronDown}
                />
            </div>
            {props.expanded && <div className={clsx(styles.content, props.className)}>{props.children}</div>}
        </div>
    </ClickAwayListener>
);

export default DateSelectorComponent;
